import { createSelector } from 'reselect';

const substate = (state) => state.policies;

export const selectPolicies = (view) => createSelector(substate, (contextState) => contextState[view]);
